module.exports = __webpack_public_path__ + "img/angular.2da413e2.svg";